import ecc from "@bitcoinerlab/secp256k1";
import { BIP32Factory } from "bip32";

import { derivePubkeyFromSpub as sodotDerivePubkeyFromSpub } from "@sodot/sodot-ed25519-hd-derivation";

export const decompressPublicKey = (compressedPubKey: string): string => {
  const pubKeyBuffer = Buffer.from(compressedPubKey, "hex");

  if (!ecc.isPoint(pubKeyBuffer)) {
    throw new Error("Invalid compressed public key");
  }

  const uncompressedPubKey = ecc.pointCompress(pubKeyBuffer, false);

  if (!uncompressedPubKey) {
    throw new Error("Failed to decompress public key");
  }

  return Buffer.from(uncompressedPubKey).toString("hex");
};

export const derivePubkeyFromXpub = (
  xpub: string,
  derivationPath: number[],
) => {
  const bip32 = BIP32Factory(ecc);

  let node = bip32.fromBase58(xpub);

  const derived = derivationPath.reduce((_, value: number) => {
    node = node.derive(value);
    return Buffer.from(node.publicKey).toString("hex");
  }, "");

  return { compressed: derived, uncompressed: decompressPublicKey(derived) };
};

export const derivePubkeyFromSpub = (
  spub: string,
  derivationPath: number[],
) => {
  const derivedPubkey = sodotDerivePubkeyFromSpub(
    spub,
    Uint32Array.from(derivationPath),
  );

  return { derived: new Uint8Array(Buffer.from(derivedPubkey, "hex")) };
};
